
/**
 * Ticket actions
 */

export default {

        won          : [{action:'payout',conditions:[]},{action:'rebet',conditions:[]}],
        open         : [{action:'cancel',conditions:[]},{action:'printCopy',conditions:[]},{action:'rebet',conditions:[]}],
        in_play      : [{action:'rebet',conditions:[]}],
        lost         : [{action:'rebet',conditions:[]}],
        payedout     : [{action:'reprintConfirmation',conditions:[]},{action:'rebet',conditions:[]}],
        closed       : [{action:'rebet',conditions:[]}],
        rejected     : [{action:'rebet',conditions:[]}],
        afterclosed  : [{action:'rebet',conditions:[]}],
        won_overdue  : [{action:'rebet',conditions:[]}],
        won_approved : [{action:'payout',conditions:[]},{action:'rebet',conditions:[]}]


};


// WEBPACK FOOTER //
// ticketActions.js